import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectKitchenStove = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('kitchen_stove')(jsonQuery),
);
